import type { StateCreator } from "zustand"

import type { AppState, ScreenSlice } from "@/store/types"

export const createScreenSlice: StateCreator<AppState, [], [], ScreenSlice> = (
  set,
) => ({
  screen: "upload",
  setScreen: (screen) => set({ screen }),
})
